module.exports = __webpack_public_path__ + "static/media/s-grid.9fd43a00.svg";